import { useMeContext } from '~/modules/me/useMeContext';
import { useIsBreakpointDown } from '~/modules/common/hooks';

export const useRepliconAssistantDetection = () => {
  const isMobile = useIsBreakpointDown('sm');
  const { featureFlags, isAISwitchOn } = useMeContext();

  const showRepliconAssistant =
    featureFlags?.repliconAssistant !== 'off' &&
    !isMobile &&
    (!featureFlags?.isPsaGenaiAskDelaToggleEnabled || isAISwitchOn);

  return showRepliconAssistant;
};
